module.exports = __webpack_public_path__ + "static/img/xz1.fd034813.png";